import React, { memo, useRef, useEffect, useState, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { dates, formats, validators, arrays } from "investira.sdk";
import {
  Stack,
  Card,
  Icon,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  DatePicker,
} from "investira.react.components";
import { StocksChart } from "investira.react.charts";
import { COTACAO_TIPO } from "@investirapri/financa.js/lib/enums";
import { VALIDATIONS } from "../../const";

const IndicadoresTabular = memo((props) => {
  const { dataInicio, dataFim, indicador, cotacoes, isPageLoading } = props;
  const xCotacaoTipo = arrays.arrayToObject(Object.values(COTACAO_TIPO), "id");
  console.log(indicador);
  const { indicador_id, divulgacao } = indicador;

  const VALIDATION_SCHEMA = Yup.object().shape({
    data_inicio: Yup.date().max(new Date()).required(VALIDATIONS.REQUIRED),
    data_fim: Yup.date().max(new Date()).required(VALIDATIONS.REQUIRED),
  });

  const formik = useFormik({
    initialValues: { data_inicio: dayjs().add(-6, "month"), data_fim: dayjs() },
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: false,
    onSubmit: (pValues, pActions) => {
      pActions.setSubmitting(true);
    },
  });

  const handleChange = (pFieldName, pFieldValue) => {
    formik.setFieldValue(pFieldName, pFieldValue, true);
  };

  const filtrarPorData = (pDados, pDataInicio, pDataFim) => {
    return pDados.filter(
      (xItem) =>
        new Date(xItem.data) >= pDataInicio && new Date(xItem.data) <= pDataFim
    );
  };

  if (validators.isEmpty(cotacoes[0].data)) {
    return null;
  }

  const xCotacoesFiltered = filtrarPorData(
    cotacoes[0].data,
    formik.values.data_inicio,
    formik.values.data_fim
  );

  console.log(formik.values, xCotacoesFiltered);

  return (
    <Stack>
      <Stack
        sx={{ gap: "16px 16px", px: 2, py: 2 }}
        flexWrap="wrap"
        direction="row"
        justifyContent="flex-end"
      >
        <DatePicker
          label="Data Início"
          name="data"
          onChange={(pValue) => {
            handleChange("data_inicio", pValue);
          }}
          value={formik.values.data_inicio}
          error={Boolean(formik.errors.data_inicio)}
          helperText={formik.errors.data_inicio}
          disabled={formik.isSubmitting}
          minDate={dayjs(dataInicio)}
          fullWidth
        />
        <DatePicker
          label="Data Fim"
          name="data"
          onChange={(pValue) => {
            handleChange("data", pValue);
          }}
          value={formik.values.data_fim}
          error={Boolean(formik.errors.data_fim)}
          helperText={formik.errors.data_fim}
          disabled={formik.isSubmitting}
          maxDate={dayjs(dataFim)}
          fullWidth
        />
      </Stack>
      <Stack>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Data</TableCell>
                {/* <TableCell>Data Divulgação</TableCell> */}
                <TableCell align="right">Cotação</TableCell>
                <TableCell align="right">Taxa</TableCell>
                <TableCell>Cotação Tipo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {xCotacoesFiltered.reverse().map((row) => (
                <TableRow
                  key={crypto.randomUUID()}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>
                    {divulgacao.periodicidade === "M"
                      ? formats.formatDateCustom(row.data, "MMM/YY")
                      : formats.formatDate(row.data)}
                  </TableCell>
                  {/* <TableCell>
                    {formats.formatDate(row.data_divulgacao)}
                  </TableCell> */}
                  <TableCell align="right">{row.cotacao}</TableCell>
                  <TableCell align="right">{row.taxa}</TableCell>
                  <TableCell>
                    {xCotacaoTipo[row.cotacao_tipo_id].descricao}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Stack>
  );
});

IndicadoresTabular.displayName = "IndicadoresTabular";

export default IndicadoresTabular;
